import moment from "moment"

export const DEMO_MEETINGS = [
  {
    meetingBookedEvent: {
      eventId: 'string',
      status: 'ACTIVE',
      slotStart: moment().set('hour', 9).set('minute', 0),
      slotEnd: 0,
      scheduledAt: 0,
      schedulerId: 0,
      endUserParticipantIds: [],
      meetingNotes: [],
      meetingType: 'Intro Meeting'
    },
    account: {
      accountId: '1_okta.com',
      name: 'Okta',
      domain: 'okta.com'
    },
    companyIntel: {
      name: 'Okta',
      domain: 'okta.com',
      logo: 'https://logo.clearbit.com/okta.com'
    },
    endUserIntel: {
      firstName: 'Nathaniel',
      lastName: 'Miller',
      displayName: 'Nathaniel Miller'
    }
  }, {
    meetingBookedEvent: {
      eventId: 'string',
      status: 'ACTIVE',
      slotStart: moment().set('hour', 11).set('minute', 30),
      slotEnd: 0,
      scheduledAt: 0,
      schedulerId: 0,
      endUserParticipantIds: [],
      meetingNotes: [],
      meetingType: 'Intro Meeting'
    },
    account: {
      accountId: '1_vozy.co',
      name: 'Vozy',
      domain: 'vozy.co'
    },
    companyIntel: {
      name: 'Vozy',
      domain: 'vozy.co',
      logo: 'https://logo.clearbit.com/vozy.co'
    }
  }, {
    meetingBookedEvent: {
      eventId: 'string',
      status: 'ACTIVE',
      slotStart: moment().add(1, 'day').set('hour', 15).set('minute', 15),
      slotEnd: 0,
      scheduledAt: 0,
      schedulerId: 0,
      endUserParticipantIds: [],
      meetingNotes: [],
      meetingType: 'Intro Meeting'
    },
    companyIntel: {
      name: 'Snap Communications Incorporated Licensed Limited',
      domain: 'teamsnap.com',
      logo: 'https://logo.clearbit.com/teamsnap.com'
    }
  }, {
    account: null,
    companyIntel: null,
    endUserIntel: null,
    meetingBookedEvent: {
      endUserTimeZone: "America/Los_Angeles",
      eventId: "4chpo90tmjeck970inj10uhlcs",
      isOrgSlug: false,
      isRecurring: false,
      meetingSlug: "meeting",
      meetingSource: "PROFILE_DROP",
      meetingType: "New Meeting",
      orgId: 1,
      scheduledAt: 1650064566000,
      schedulerId: 13887887575,
      slotStart: moment().add(1, 'day').set('hour', 15).set('minute', 15),
      slotEnd: 0,
      slug: "qJAaAbn0Km",
      status: "ACTIVE",
      updatedAt: 1650064567240
    }
  }, {
    meetingBookedEvent: {
      agentId: 5058066,
      orgId: 1,
      status: "ACTIVE",
      meetingSource: "PLAYBOOK_DROP",
      schedulerId: 0,
      eventId: "6pv60a7ls78fcnebfeniib8ec0",
      slotStart: moment().add(1, 'day').set('hour', 17).set('minute', 0),
      slotEnd: 1648737000000,
      updatedAt: 1648574665471,
      scheduledAt: 1648574665000,
      meetingType: "New Meeting",
      meetingSlug: "meeting",
      isOrgSlug: false,
      endUserTimeZone: "Europe/Amsterdam"
    },
    endUserIntel: {
      firstName: "Larry",
      lastName: "Page",
      displayName: "Larry Page",
      employmentTitle: "Wizard",
      linkedinHandle: "in/larry-page",
      avatarUrl: 'https://imageio.forbes.com/specials-images/imageserve/5c76bcaaa7ea43100043c836/0x0.jpg?format=jpg&crop=1795,1795,x227,y22,safe&fit=crop'
    },
  }
]